export const CACHE_KEY_PREFIX = "$apiParty";
